<script>
import debounce from 'lodash/debounce'
import api from '@/api'

export default {
  props: {
    persistentItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      items: [...this.persistentItems],
      initialized: false
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch(query) {
      try {
        const response = await api.getUserTagList({
          limit: 25,
          offset: 0,
          filter_name: query,
          sort: 'name_asc'
        })
        if (!response.success) return
        this.items = [...this.persistentItems, ...response.result.map((item) => item.name)]
        this.initialized = true
      } catch (error) {
        console.error(error)
      }
    },
    async onSearch({ event, onComplete }) {
      try {
        await this.fetch(event)
      } catch (error) {
        console.error(error)
      } finally {
        onComplete(this.items)
      }
    }
  },
  render() {
    return this.$scopedSlots.default({
      initialized: this.initialized,
      items: this.items,
      onSearch: debounce(this.onSearch, 500)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/providers/TagProvider.vue